import React from 'react';
import {useSelector} from 'react-redux';
import {useLanguage} from '../../i18n';
import {ApplicationState, useActionCreator} from '../../store';
import {setLanguage} from '../../store/settings/actions';
import {isLang, Language} from '../../constants/language';
import './languageSelector.scss';
import {MdSelect, MdSelectOption} from "@miljodirektoratet/md-react";

const languageOptions: MdSelectOption[] = [
    { value: Language.NO, text: 'Norsk' },
    { value: Language.SV, text: 'Svenska' },
    { value: Language.EN, text: 'English' }
];

export function LanguageSelector(): React.ReactElement {
    const l = useLanguage();
    const language = useSelector((state: ApplicationState) => state.settings.language);
    const updateLanguage = useActionCreator(setLanguage);
    const changeHandler = (value: string): void => {
        if (isLang(value)) updateLanguage(value);
    };

    return (
        <div className="language-selector">
            <label htmlFor={'languageSelector'}>
                    {l('languageSelect.language')}
            </label>
            <MdSelect
                id={'languageSelector'}
                value={language}
                options={languageOptions}
                onSelectOption={changeHandler}
                allowReset={false}
                mode="small"
            />
        </div>
    );
}
